import type { FixedAssetListItem } from '@/services/fixedAssets'
import {
  formatFixedAssetMoney,
  formatIsoDate,
  parseMoney,
} from './fixedAssetsFormat'
import {
  SCHEDULES_COLUMN_KEYS,
  SCHEDULES_COLUMN_LABELS,
} from './fixedAssetsSchedulesTableConfig'

function schedulesExportMethod(asset: FixedAssetListItem): string {
  return asset.method.replace(/_/g, ' ')
}

function schedulesExportLife(asset: FixedAssetListItem): string {
  return asset.non_depreciable ? '—' : `${asset.useful_life_years} yrs`
}

function schedulesExportPctDepreciated(asset: FixedAssetListItem): string {
  const pct = parseMoney(asset.pct_depreciated)
  return `${pct.toFixed(0)}%`
}

function schedulesExportFlags(asset: FixedAssetListItem): string {
  return asset.flags.map((flag) => flag.label).join('; ')
}

function schedulesExportRow(asset: FixedAssetListItem): string[] {
  return SCHEDULES_COLUMN_KEYS.map((key) => {
    switch (key) {
      case 'name':
        return asset.name
      case 'asset_class':
        return asset.asset_class
      case 'location':
        return asset.location
      case 'in_service':
        return formatIsoDate(asset.dep_start_date)
      case 'method':
        return schedulesExportMethod(asset)
      case 'useful_life_years':
        return schedulesExportLife(asset)
      case 'purchase_price':
        return formatFixedAssetMoney(asset.purchase_price)
      case 'salvage_value':
        return formatFixedAssetMoney(asset.salvage_value)
      case 'accum_to_date':
        return formatFixedAssetMoney(asset.accum_to_date)
      case 'nbv':
        return formatFixedAssetMoney(asset.nbv)
      case 'monthly_run_rate':
        return formatFixedAssetMoney(asset.monthly_run_rate)
      case 'pct_depreciated':
        return schedulesExportPctDepreciated(asset)
      case 'flags':
        return schedulesExportFlags(asset)
      default:
        return ''
    }
  })
}

export function buildSchedulesExportMatrix(assets: FixedAssetListItem[]): {
  headers: string[]
  rows: string[][]
} {
  const headers = SCHEDULES_COLUMN_KEYS.map((key) => SCHEDULES_COLUMN_LABELS[key])
  const rows = assets.map(schedulesExportRow)
  return { headers, rows }
}
